
(function($, window, undefined) {

  var defaults = {
    selectorPrefix: 'wbsk-cart'
  };

  var ShopifyRoot = window.Shopify.routes.root;

	function nodeScriptReplace(node) {
		if ( nodeScriptIs(node) === true ) {
			console.log(node);
			node.parentNode.replaceChild( nodeScriptClone(node) , node );
		}
		else {
			var i        = 0;
			var children = node.childNodes;
			while ( i < children.length ) {
				nodeScriptReplace( children[i++] );
			}
		}

		return node;
	}

	function nodeScriptIs(node) {
		return node.tagName === 'SCRIPT';
	}

	function nodeScriptClone(node){
		var script  = document.createElement("script");
		script.text = node.innerHTML;
		for( var i = node.attributes.length-1; i >= 0; i-- ) {
			script.setAttribute( node.attributes[i].name, node.attributes[i].value );
		}
		return script;
	}

  function wbskCart(element, settings) {
    this.element = $(element)
    this.settings = $.extend({}, defaults, settings);
    this.removeCtrl = `.${this.settings.selectorPrefix}__remove-from-cart`;
    this.qtySelector = `.${this.settings.selectorPrefix}__item-qty-selector`;
    this.qtyCtrl = `.${this.settings.selectorPrefix}__item-qty`;
    this.qtyPlus = `.${this.settings.selectorPrefix}__item-qty-plus`;
    this.qtyMinus = `.${this.settings.selectorPrefix}__item-qty-minus`;
    this.wrapper = `.${this.settings.selectorPrefix}__wrapper`;
    this.cartTemplate = $(`.${this.settings.selectorPrefix}__cart-template`);
    this.count = $(`.${this.settings.selectorPrefix}__cart-count`);
    this.actions = `.${this.settings.selectorPrefix}__actions`;
    this.empty = `.${this.settings.selectorPrefix}__empty`;
    this.bind();
    this.udpate('init');
  };

  wbskCart.prototype = {

    bind: function() {
        var _this = this;
        //remove item
        $(document).on('click', this.removeCtrl, function(e) {
            e.preventDefault();
            _this.removeItem($(this));
        });

        $(document).on('click', this.qtyPlus, function (e) {
            e.preventDefault();

            let $input = $(this).closest('.wbsk-cart__item-qty-selector--custom').find(_this.qtyCtrl);
            $input.attr('value', $input.val()*1 +1);
            $input.change();
        }.debounce(1000));

        $(document).on('click', this.qtyMinus, function (e) {
            e.preventDefault();

            let $input = $(this).closest('.wbsk-cart__item-qty-selector--custom').find(_this.qtyCtrl);
            $input.attr('value', $input.val()*1 -1);
            $input.change();
        }.debounce(1000));

        //qty change event
        $(document).on('change', this.qtyCtrl, function (e) {
            e.preventDefault();
            _this.updateQty($(this));
        }.debounce(1000));

        _this.cartTemplate.find(_this.qtySelector).qntSel();
    },

    addToCart:function(data){
        var _this = this;


        return new Promise(function (resolve, reject) {
            _this.fetchHandler(`${ShopifyRoot}cart/add.js?${data}`).then(function (result) {
                return result.json();
            }).then(function (cart) {
                _this.udpate('add').then(function () {
                    if (_this.settings.onAdded && typeof _this.settings.onAdded == 'function') {
                        _this.settings.onAdded(cart);
                    }

                    resolve(cart);
                });
            }).catch(function (error) {
                console.log(error);
                reject(error);
            });
        });
    },

    addMultipleToCart:function(data){
        var _this = this
        return new Promise(function(resolve,reject){
            //create the request data
            var requests = data.map(function (item) {
                var request = {
                    id: item.id
                };
                return $.param(request);
            });

            //pass them to the ATC function
            var results = [];
            requests.reduce(function(promise, request){
                return promise
                    .then(function(result){
                        return _this.addToCart(request).then(function(result){results.push(result)});
                    })
                    .catch(console.error);
                },
                Promise.resolve().then(function () {
                    resolve(results);
                })
            );

        })
    },

    udpate:function(type){
      var _this = this,
          url = _this.settings.cartFetchUrl;
      return new Promise(function(resolve,reject){
        if(_this.settings.loadingClass && _this.settings.loadingClassElement){
          _this.settings.loadingClassElement.addClass(_this.settings.loadingClass)
        }
        _this.fetchHandler(url).then(function(result){
          return result.text();
        }).then(function(html){
          _this.cartTemplate.html(html)
          if(_this.settings.loadingClass && _this.settings.loadingClassElement){
            _this.settings.loadingClassElement.removeClass(_this.settings.loadingClass)
          }
          _this.getCartJSON().then(function(cart){

			_this.getCartUpsells().then(function (response) {
				const CartUpsells = document.createElement("div");
				CartUpsells.innerHTML = response;

				let outHTML = CartUpsells.querySelector('#cart_upsells_container').innerHTML;

				document.querySelector('[data-slideout="product_upsell"]').innerHTML = outHTML;
				nodeScriptReplace(document.querySelector('[data-slideout="product_upsell"]'));
				header_slideouts = {
					$wrap:$('.s-outs__wrap'),
					$inner:$('.s-outs__inner'),
					bind:function(){
						$('[data-slideout__open]').click(function(e){
							e.preventDefault();
							header_slideouts.open($(this).attr('data-slideout__open'));
						});
						$('[data-slideout="close"]').click(function(e){
							e.preventDefault();
							header_slideouts.close();
						});
					},
					open:function(target){
						header_slideouts.$wrap.fadeIn(200,function(){
							$('[data-slideout="'+target+'"]').addClass('is-active');
							window_scroll_lock.lock();
						});
					},
					close:function(){
						header_slideouts.$inner.removeClass('is-active');
						setTimeout(function(){
							header_slideouts.$wrap.fadeOut(200);
							window_scroll_lock.unlock();
						},400);
					},
				};
				header_slideouts.bind();
			});

            //update the cart counter
            var countMinusHidden = 0;
            for (var i = 0; i < cart.items.length; i++) {
              if (cart.items[i].properties && cart.items[i].properties._hide_in_cart) {
                continue;
              }

              countMinusHidden += cart.items[i].quantity;
            }

	       _this.count.text(countMinusHidden)
            //bind the qty selectors
            _this.cartTemplate.find(_this.qtySelector).qntSel()
            //fire the update event
            var event = new CustomEvent('update' , {bubbles: true});
            event.updateType = type
            event.cart = cart
            _this.element[0].dispatchEvent(event);
            resolve()
          })
        })
      })
    },

    updateQty:function($item){
      var _this = this,
          url = $item.attr('data-update') + $item.val();
      if(_this.settings.loadingClass && _this.settings.loadingClassElement){
        _this.settings.loadingClassElement.addClass(_this.settings.loadingClass)
      }
      _this.fetchHandler(url).then(function(res){
      	_this.getCartJSON().then(function(cart){
      		let thisProductInCart = cart.items.find(item => item.key === $item.attr('data-id'));
      		if (thisProductInCart?.properties['_bundleGroup']) {
      			cart.items.forEach((item, lineKey) => {
      				if (item.properties['_bundleGroup'] === thisProductInCart.properties['_bundleGroup'] && item.properties['_hide_in_cart'] === 'true') {
      					_this.fetchHandler(`/cart/change?line=${lineKey+1}&quantity=${thisProductInCart.quantity}`).then(function(res){
      						_this.udpate()
      					});
      				}
      			});
      		}

      		if (!thisProductInCart) {
      			if (_this.removeLostProduct() === 'ok') {
      				_this.udpate()
      			}
      		} else {
      			_this.udpate()
      		}
      	});
      });
    },

    removeItem:function($item){
      var _this = this;
      if(_this.settings.loadingClass && _this.settings.loadingClassElement){
        _this.settings.loadingClassElement.addClass(_this.settings.loadingClass)
      }
      _this.fetchHandler($item.attr('href')).then(function(res){
        _this.udpate('remove')
      })

    },

    fetchHandler:function(url){
      return new Promise(function(resolve,reject){
        fetch(url).then(function(result){
          resolve(result)
        }).catch(function(error){
          reject(error)
        })
      })
    },

    getCartJSON:function(){
      var _this = this
      return new Promise(function(resolve,reject){
        fetch(ShopifyRoot+'cart.js').then(function(result){
          return result.json()
        }).then(function(data){
          resolve(data)
        });
      })
    },

	getCartUpsells:function () {
		var _this = this;

		return new Promise(function(resolve,reject){
			fetch(location.pathname + '?view=cart_upsells').then(function(result){
				return result.text()
			}).then(function(data){
				resolve(data)
			});
		})
	},

	removeLostProduct: function () {
      var _this = this;
    	_this.getCartJSON().then(function(cart){
    	  cart.items.forEach((item, lineKey) => {
    	  	if (item.properties['_bundleGroup'] && item.properties['_hide_in_cart'] === 'true') {
    		  let thisProductInCart = item;
    		  let mainProductInGroup = cart.items.find(item => item.properties['_bundleGroup'] === thisProductInCart.properties['_bundleGroup'] && item.properties['_hide_in_cart'] !== 'true')
				if (!mainProductInGroup) {
				  _this.fetchHandler(`/cart/change?line=${lineKey+1}&quantity=0`).then(function(res){
				  	_this.removeLostProduct();
				  	return false;
				  });
				}
    	  	}
    	  });
    	  _this.udpate();
    	  return 'ok';
    	});
	  }
  };

  $.fn.wbskCart = function(settings) {
    return this.each(function () {
      $.data(this, 'wbskCart', new wbskCart(this, settings))
    })
  }

}(jQuery, window));

